"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Carousel = _interopRequireWildcard(require("./Carousel.style"));

var CarouselArrow = function CarouselArrow(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      variant = _ref.variant;
  return /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    onClick: onClick,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_Carousel.StyledIcon, {
    name: "ChevronRight",
    color: color
  }));
};

CarouselArrow.propTypes = {
  color: _propTypes.default.string,
  onClick: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['left', 'right'])
};
CarouselArrow.defaultProps = {
  color: '#000',
  onClick: _propTypes.default.func,
  variant: 'right'
};
var _default = CarouselArrow;
exports.default = _default;